import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const OneDayVIPContentStyles = styled.div`
  height: 200px;
  border-radius: 16px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  width: 100%;
  background: linear-gradient(90deg, #803eff 0%, #ff3636 100%);
  padding: 2px;
`;

export const OneDayVIPContentContainerStyles = styled.div`
  position: absolute;
  bottom: 2px;
  left: 2px;
  height: 196px;
  width: calc(100% - 4px);
  background: #28102e;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const OneDayVIPCardStyles = styled.div`
  width: 100%;
  height: 196px;
  padding: 20px 16px;
  text-align: center;
`;

export const OneDayVIPIconStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;

export const OneDayVIPTitleStyles = styled(UiTypography)`
  margin: 0 0 8px 0;
`;

export const OneDayVIPDescriptionStyles = styled(UiTypography)`
  margin: 0 0 12px 0;
`;

export const OneDayVIPPriceStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .original-price {
    text-decoration: line-through;
  }
`;
